module.exports = __webpack_public_path__ + "static/img/benjyfishy.7382879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/hero/benjyfishy.png
// module id = er3x
// module chunks = 38